import type { AppPatternRouteProps } from "@glide/common-core/dist/js/routes";
import { appPattern } from "@glide/common-core/dist/js/routes";
import { useRouteMatch } from "react-router-dom";

export function useIsAgentRoute() {
    const match = useRouteMatch<AppPatternRouteProps>(appPattern);
    return match?.params.page === "agent";
}
